<!-- title -->
<app-modal-title
  [title]="'common.cellsByName' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="xl:tw-w-[350px] sm:w-full">
      <div class="tw-w-full">
        <div class="tw-flex-center tw-flex-col">
          <!-- names -->
          <!-- <form-textarea
            class="tw-w-full"
            [control]="form?.get('names')"
            label="common.names"
            [(value)]="names"
            [rows]="5"
            [placeholder]="namesPlaceHolder"
          >
          </form-textarea> -->
          <!-- alert -->
          <div
            class="alert tw-bg-gray-50 dark:tw-bg-dark-200 border tw-mt-1 tw-w-full"
          >
            <details [open]="true">
              <summary class="tw-font-semibold text-navyBlue">
                {{ "common.help" | translate }}
              </summary>
              <div
                class="dark:tw-text-gray-300"
                [innerHTML]="
                  'messages.cellsWidgetMessage'
                    | translate
                      : {
                          downloadFile: 'common.downloadFile' | translate
                        }
                "
              ></div>
            </details>
          </div>
          
          <cells-widget
            [form]="form"
            [cellList]="result?.[0]?.cellList"
            controlName="names"
            (names)="names = $event"
            (selectedMode)="selectedMode = $event;showChangeSelectedModeDialog()"
          ></cells-widget>
        </div>
        <div
          *ngIf="
            result && result[0]?.cellList.length > 0 && selectedMode == 'manual'
          "
          class="tw-bg-gray-100 dark:tw-bg-gray-800 dark:tw-border-gray-600 tw-border-dashed tw-border-2 tw-text-center tw-mt-[10px] fw-bold tw-rounded-[10px] tw-items-center rounded p-5"
        >
          {{ "common.cellListIds" | translate }}

          <mat-chip-grid class="mt-5" [ariaOrientation]="'vertical'">
            <ng-container *ngFor="let filterItem of result[0]?.cellList">
              <ng-container>
                <mat-chip-row>
                  {{ filterItem }}
                </mat-chip-row>
              </ng-container>
            </ng-container>
          </mat-chip-grid>
        </div>
        <div
          *ngIf="result && result[0]?.cellList?.length == 0"
          class="tw-bg-gray-100 dark:tw-bg-gray-800 dark:tw-border-gray-600 tw-border-dashed tw-border-2 tw-text-center tw-mt-[10px] fw-bold tw-rounded-[10px] tw-items-center rounded p-5"
        >
          {{ "common.empty" | translate }}
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [customTitle]="'common.search'"
      [btnType]="'submit'"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
